import {
    Box, Card, CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    Grid2, Stack,
    Typography
} from "@mui/material";
import {ReportTypes} from "../../types";
import React from "react";
import {LoadingButton} from "@mui/lab";
import {CrimeReportList} from "../../pages/app/reports/crime-report-list/crime-report-list";
import {crimeScoreRiskDescription, getCrimeScoreRisk} from "../../helpers/crimeScore";
import {SexOffendersInfo} from "../../pages/app/reports/sex-offenders-info/sex-offenders-info";

export interface Props {
    visible: boolean,
    onClose: () => void
    report : ReportTypes.Model
}

export const SafetyReportDialog: React.FC<Props> = ({ visible, onClose, report}) => {
    let address = report?.address!;
    let sexOffenders = report?.sexOffender?.sexOffendersAtLocation!
    let crimeScore = report?.crimeScore!
    let sexOffendersWithin3M = report?.sexOffender?.sexOffenderNearByCount!
    let nearbyReports = report?.nearbyReports ?? []
    return (
        <Dialog
            open={visible}
            onClose={onClose}
            maxWidth="lg"
        >
            <DialogContent>
                <Grid2>
                    <Card className={'div-border-for-download'}>
                        <CardContent sx={{padding:5}}>
                            <Stack>
                                <Box sx={{textAlign:'center',marginBottom:3}}>
                                    <Typography fontWeight={500} fontSize={20} lineHeight={"24px"}>
                                        {address}
                                    </Typography>
                                </Box>
                                <CrimeReportList data={
                                    sexOffenders?.length > 0
                                        ? [
                                            {
                                                crimeRisk:
                                                    getCrimeScoreRisk(
                                                        crimeScore,
                                                        sexOffenders?.length
                                                    )!,
                                                description:
                                                    crimeScoreRiskDescription[
                                                        getCrimeScoreRisk(
                                                            crimeScore,
                                                            sexOffenders?.length
                                                        )!
                                                        ],
                                                crimeScore,
                                            },
                                        ]
                                        : []
                                }
                                />
                                <SexOffendersInfo place={report?.place} crimeScore={crimeScore} address={address} sexOffenders={sexOffenders} sexOffendersWithin3M={sexOffendersWithin3M}/>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid2>
                <DialogActions sx={{ mb: -2, mt: -2, mr: -3 }}>
                    <Grid2
                        marginTop={20}
                        flexDirection={'row-reverse'}
                        container
                        spacing={2}
                        mt={3}
                    >
                        <LoadingButton
                            variant="outlined"
                            color="inherit"
                            onClick={onClose}
                            disabled={false}
                            loading={false}
                        >
                            Close
                        </LoadingButton>
                    </Grid2>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}